module.exports = "<a href class=\"heading-h5 option-toggle__item\" ng-class=\"{\n    'option-toggle__item--active': active\n  }\" ng-click=onClick() ng-bind=label> </a> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/toggle-option/toggle-option.html
// module id = 307
// module chunks = 0